
import { useState } from "react";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../../../../utils/api";
import { LoginHelper } from "../../../../utils/LoginHelper";
import EditorFieldSection from "../../../common/editor/EditorFieldSection";
import EditorFormShell from "../../../common/editor/EditorFormShell";
import FieldDescription from "./FieldDescription";
import FieldDuration from "./FieldDuration";
import FieldImage from "./FieldImage";
import FieldTitle from "./FieldTitle";
import FieldVideo from "./FieldVideo";


export default function Form() {
	const navigate = useNavigate();
	const params = useParams();
	const workshopId = params.workshopId;
	const [title, setTitle] = useState('');
	const [description, setDescription] = useState('');
	const [duration, setDuration] = useState('');
	const [image, setImage] = useState(null);
	const [video, setVideo] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');

	const handleTitleChange = (e) => {
		setTitle(e.target.value);
	}

	const handleDescriptionChange = (e) => {
		setDescription(e.target.value);
	}

	const handleDurationChange = (e) => {
		setDuration(e.target.value);
	}

	const handleImageChange = (e) => {
		setImage(e.target.files[0]);
	}

	const handleVideoChange = (e) => {
		setVideo(e.target.files[0]);
	}

	const handleSubmit = () => {
		if (isLoading) return;
		setIsLoading(true);
		api.episodeAdd({
			token: LoginHelper.getToken(),
			workshop_id: workshopId,
			title: title,
			description: description,
			duration: duration,
			image_file: image,
			video_file: video,
		}).then((res) => {
			setIsLoading(false);
			navigate('/workshop_detail/' + workshopId + '/');
		}).catch((err) => {
			setIsLoading(false);
			if (err && err.data) {
				setErrorMessage(err.data.message);
			}
		});
	}

	return (
		<EditorFormShell
			title="افزودن جلسه"
			subtitle="جلسه جدید به کارگاه اضافه می‌شود؛ ویدیو و مدت زمان را وارد کنید."
			errorMessage={errorMessage}
			onSubmit={handleSubmit}
			isLoading={isLoading}
			submitLabel="افزودن جلسه"
		>
			<EditorFieldSection title="اطلاعات جلسه">
				<FieldTitle title={title} onChange={handleTitleChange} />
				<FieldDescription description={description} onChange={handleDescriptionChange} />
				<FieldDuration duration={duration} onChange={handleDurationChange} />
			</EditorFieldSection>
			<EditorFieldSection title="فایل‌ها">
				<FieldImage onChange={handleImageChange} />
				<FieldVideo onChange={handleVideoChange} />
			</EditorFieldSection>
		</EditorFormShell>
	);
}
